import firebase from "firebase"
import { useState } from "react"
import { Alert } from "react-bootstrap"
import { Redirect } from "react-router-dom"

export default function Signout(){
    var [doRedirect, setDoRedirect] = useState(false)

    function handleSignout(){
        setTimeout(() => {
            setDoRedirect(true)
        }, 3000);
    }

    async function signout(){
        await firebase.auth().signOut()
        .then(function() {
            console.log("User has Signed Out")
        })
        .catch((err) => {
            console.log(err)
        })
    }

    signout()
    handleSignout()
    
    return (
        <div>
            {doRedirect? 
                <Redirect to="/"></Redirect>:
                <Alert variant="danger">You have signed out</Alert>
            }
        </div>
    )
}
